// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GridPageLogic__children--hidden":"cl_a bie_c","GridPageLogic__locations__placesRadius":"cl_b bie_sv"};